var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9332 6.55935C24.4804 5.1036 22.2824 5.75272 21.13 5.87409C20.3151 5.95986 19.5205 6.3145 19.4094 5.56557C19.1377 3.73414 19.1204 2.13195 17.5078 0.480556C16.4211 -0.632054 15.1698 0.425897 15.6062 1.25104C16.5119 3.56254 16.2103 5.44619 12.5 5.44619C8.78965 5.44619 8.48803 3.56254 9.3937 1.25104C9.83008 0.425897 8.57876 -0.632054 7.49213 0.480556C5.87944 2.13195 5.8622 3.73414 5.59057 5.56557C5.47944 6.3145 4.68491 5.95986 3.86992 5.87409C2.71752 5.75272 0.51962 5.1036 0.0667873 6.55935C-0.358457 7.92628 1.24413 10.2403 4.95654 10.754C5.49985 11.0966 5.22817 20 12.5 20C19.7718 20 19.5001 11.0966 20.0434 10.754C23.7559 10.2403 25.3585 7.92628 24.9332 6.55935Z",
    fill: "#118f84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrc);
export default __webpack_public_path__ + "static/media/KRC.6ac0b7b8eb1e7c4f907dd420a46c6fbf.svg";
export { ForwardRef as ReactComponent };